export const getInitials = ( name ) => {
    const [ firstName, lastName ] = name.split(" ")
    return lastName ? firstName[0] + lastName[0] : firstName[0];
};
